var Dlrt;
(function (Dlrt) {
    class TimelineWithCommentsBase extends Dlrt.TimelineBase {
        constructor(view, options = null) {
            super(view, options);
            this.newCommentBox = this.find('#addCommentRow #newCommentBox');
            this.commentError = $(options.commentErrorSelector);
            this.removeCommentConfirmationModal = $(options.removeCommentConfirmationModalSelector);
            this.initCommentsEvents();
        }
        get CommentOptions() {
            return this.Options;
        }
        onSuccess() {
            this.ResultsContainer.find('[data-toggle=tooltip]').tooltip();
            this.ResultsContainer.find('.delphi-timeline-edit-event-button').on('click', e => this.startEditEvent(e));
            this.ResultsContainer.find('.delphi-timeline-remove-event-button').on('click', e => this.startRemoveEvent(e));
        }
        initCommentsEvents() {
            this.find('#addCommentRow #addCommentButton').on('click', () => this.addComment());
            this.removeCommentConfirmationModal.find('#confirmRemoveCommentButton').on('click', (e) => this.removeEvent(e));
        }
        startEditEvent(e) {
            const eventBlock = this.findTimelineEventRoot($(e.target));
            eventBlock.find('.delphi-timeline-event-description-box').addClass('hidden');
            eventBlock.find('.delphi-timeline-event-edition-box').removeClass('hidden');
            eventBlock.find('.delphi-timeline-event-edition-box textarea').focus();
            eventBlock.find('.delphi-timeline-event-edition-box textarea').on('focusout', (e) => this.editEvent(e));
        }
        findTimelineEventRoot(e) {
            return e.closest('li.delphi-timeline-result');
        }
        startRemoveEvent(e) {
            this.removeCommentConfirmationModal.find('#confirmRemoveCommentButton').data('event-id', $(e.target).data('event-id'));
            this.removeCommentConfirmationModal.modal('show');
        }
        addComment() {
            const comment = this.newCommentBox.val();
            if (!comment.trim()) {
                this.showCommentError('empty-comment');
                return;
            }
            // calling convention for adding comment is "same as query, with an additional parameters for the comment itself"
            const data = $.extend({}, this.Options.queryParameters, { comment: comment });
            this.postToController({
                action: 'AddComment',
                data: data,
                success: () => {
                    this.hideCommentError();
                    this.newCommentBox.val('');
                    this.getContent();
                },
                error: () => {
                    this.showCommentError('internal');
                }
            });
        }
        editEvent(e) {
            const newComment = $(e.target).val();
            if (!newComment.trim()) {
                this.showCommentError('empty-comment');
                this.getContent();
                return;
            }
            this.postToController({
                action: 'EditComment',
                data: {
                    eventId: $(e.target).data('event-id'),
                    newComment: newComment
                },
                success: () => {
                    this.hideCommentError();
                    const eventBlock = this.findTimelineEventRoot($(e.target));
                    eventBlock.find('span.delphi-timeline-event-description').text($(e.target).val());
                    eventBlock.find('.delphi-timeline-event-description-box').removeClass('hidden');
                    eventBlock.find('.delphi-timeline-event-edition-box').addClass('hidden');
                    eventBlock.find('.delphi-timeline-event-edition-box textarea').off('focusout');
                },
                error: () => {
                    this.showCommentError('internal');
                    this.getContent();
                }
            });
        }
        removeEvent(e) {
            const eventId = $(e.target).data('event-id');
            this.postToController({
                action: 'RemoveComment',
                data: {
                    eventId: eventId
                },
                success: () => {
                    this.hideCommentError();
                    this.ResultsContainer.find('li[data-event-id=' + eventId + ']').remove();
                    this.removeCommentConfirmationModal.modal('hide');
                },
                error: () => {
                    this.showCommentError('internal');
                    this.removeCommentConfirmationModal.modal('hide');
                    this.getContent();
                }
            });
        }
        showCommentError(dataTag) {
            let message = this.commentError.data(dataTag + '-error-message');
            if (!message) {
                message = 'An error has occurred';
            }
            this.commentError.text(message);
            this.commentError.removeClass('hidden');
        }
        hideCommentError() {
            this.commentError.addClass('hidden');
        }
        postToController(action) {
            $.ajax({
                url: this.CommentOptions.commentActionUrlPrefix + action.action,
                type: 'POST',
                data: action.data,
                cache: false,
                traditional: true,
                success: action.success,
                error: action.error
            });
        }
    }
    Dlrt.TimelineWithCommentsBase = TimelineWithCommentsBase;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=timelineWithCommentsBase.js.map
